import { Routes } from '@angular/router';
import { MAIN_SLUGS } from '@routes/routes.types';

export const AGENT_CHAT_ROUTE: Routes = [
    {
        path: MAIN_SLUGS.agentChat,
        title: 'AI Chat',
        loadComponent: () =>
            import('./agent-chat-page/agent-chat-page.component').then(m => m.AgentChatPageComponent),
    },
];
